import { render, staticRenderFns } from "./VMap.vue?vue&type=template&id=446e64d8"
import script from "./VMap.vue?vue&type=script&lang=ts"
export * from "./VMap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports